export default "/_next/static/images/product-reports-4989129cb222f2524ed7df10845fd7b6.svg";